// API Configuration
const API_CONFIG = {
  BASE_URL: 'https://el1rqrkcbf.execute-api.us-east-1.amazonaws.com/prod',
  ENDPOINTS: {
    REQUEST_SERVICES: '/request-services'
  }
};

export default API_CONFIG;
